import React, { Component } from "react";
import axios from "axios";
import { Image } from "react-bootstrap";
import classnames from "classnames";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

import { InputBoxComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

import { serverApi } from "../../../../../config/Keys";
import { ViewProfileDisplayButton } from "../../reusableSuperAdminButton/ViewProfileDisplayButton";

export class SuperAdminProfilePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      addIcon: "",
      birthdayDate: "",
      birthdayMonth: "",
      anniversaryDate: "",
      anniversaryMonth: "",
      dayEatOut: [
        {
          id: 1,
          title: "Mon",
          category: "DayEatOut",
        },
        { id: 2, title: "Tue", category: "DayEatOut" },
        {
          id: 3,
          title: "Wed",
          category: "DayEatOut",
        },
        { id: 4, title: "Thu", category: "DayEatOut" },
        {
          id: 5,
          title: "Fri",
          category: "DayEatOut",
        },
        { id: 6, title: "Sat", category: "DayEatOut" },
        {
          id: 7,
          title: "Sun",
          category: "DayEatOut",
        },
      ],
      favoriteCuisine: [
        {
          id: 1,
          title: "Jain",
          category: "favoriteCuisine",
        },
        {
          id: 2,
          title: "North Indian",
          category: "favoriteCuisine",
        },
        {
          id: 3,
          title: "South Indian",
          category: "favoriteCuisine",
        },
        {
          id: 4,
          title: "Chinese",
          category: "favoriteCuisine",
        },
        {
          id: 5,
          title: "Japanese",
          category: "favoriteCuisine",
        },
      ],
      favoritePopularChains: [
        {
          id: "1",
          icon: "https://iconslist.s3.amazonaws.com/Casual+Dining.png",
          title: "Casual Dining",
          category: "favoritePopularChains",
        },
        {
          id: "2",
          icon: "https://iconslist.s3.amazonaws.com/Fine+Dining.png",
          title: "Fine Dining",
          category: "favoritePopularChains",
        },
        {
          id: "3",
          icon: "https://iconslist.s3.amazonaws.com/Cafe.png",
          title: "Cafe",
          category: "favoritePopularChains",
        },
      ],
      favoritePlaces: [
        {
          id: 1,
          title: "Casual Dining",
          category: "favoritePlaces",
        },
        {
          id: 2,
          title: "Fine Dining",
          category: "favoritePlaces",
        },
        {
          id: 3,
          title: "Cafes",
          category: "favoritePlaces",
        },
        {
          id: 4,
          title: "Bar / Pub",
          category: "favoritePlaces",
        },
      ],
      dietaryPreferences: [
        {
          id: 1,
          title: "Low Carb",
          category: "dietaryPreferences",
        },
        {
          id: 2,
          title: "Protein Rich",
          category: "dietaryPreferences",
        },
        {
          id: 3,
          title: "Vegan",
          category: "dietaryPreferences",
        },
        {
          id: 4,
          title: "Lactose Free",
          category: "dietaryPreferences",
        },
      ],
      yourAllergyInfo: [
        {
          id: 1,
          title: "Milk",
          category: "yourAllergyInfo",
        },
        {
          id: 2,
          title: "Soy",
          category: "yourAllergyInfo",
        },
        {
          id: 3,
          title: "gluten",
          category: "yourAllergyInfo",
        },
        {
          id: 4,
          title: "nuts",
          category: "yourAllergyInfo",
        },
        {
          id: 5,
          title: "seafood",
          category: "yourAllergyInfo",
        },
        {
          id: 6,
          title: "egg",
          category: "yourAllergyInfo",
        },
        {
          id: 7,
          title: "sesame",
          category: "yourAllergyInfo",
        },
        {
          id: 8,
          title: "mushroom",
          category: "yourAllergyInfo",
        },
      ],
      errors: {},
    };
  }

  openModal = () => {
    this.setState({ open: !this.state.open });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/
  onImageLogoUploadHandler = (e) => {
    this.setState({ loader: true });
    const data = new FormData();
    data.append("image", e.target.files[0]);
    axios
      .post(`${serverApi}/image/upload-content-images`, data)
      .then((res) => {
        this.setState({ addIcon: res.data.image_URL, loader: false });
      })
      .catch((err) => {
        this.setState({ loader: false });
        window.alert("Error while uploading the image");
      });
  };

  render() {
    const { open, errors } = this.state;
    return (
      <React.Fragment>
        <div className="super-admin-icon-box-width">
          <Image
            src={
              this.props.src
                ? require("../../../../../assets/images/OfferAndEventImages/edit.png")
                : require("../../../../../assets/images/OfferAndEventImages/view.png")
            }
            alt="View Icon"
            title="View Profile"
            fluid
            onClick={this.openModal}
          />
        </div>
        <Modal
          open={open}
          onClose={this.openModal}
          center
          classNames={{
            overlay: "customOverlay-request-accept-cancelled",
            modal: "super_admin_all_users_view_profile",
            closeButton: "customCloseButtonCalling",
            animationIn: "customEnterAnimation",
            animationOut: "customLeaveAnimation",
          }}
          animationDuration={1000}
        >
          <div>
            <div className="top-headerbar">
              <h3>View User Details</h3>
              <Image
                fluid
                src={require("../../../../../assets/images/AuthImages/menu.png")}
                onClick={this.openModal}
                alt="Remove Icon"
              />
            </div>
            <div className="super_admin_all_users_view_profile-body">
              <div className="d-flex align-items-baseline">
                <div className="file_upload_superadmin file-upload-superadmin-all-user-images">
                  <div className="view_chainsBor restaurant_details_onboarding_file_upload mt-0">
                    <div className="custom_file_upload list_icon_custom_file_upload ">
                      <input
                        type="file"
                        name="icon"
                        id="file"
                        onChange={this.onImageLogoUploadHandler}
                        className="custom_input_upload"
                      />
                      <label
                        className="custom_input_label newChain_add"
                        htmlFor="file"
                      >
                        <div>
                          <i
                            className="fa fa-plus"
                            style={{ color: "#CCCCCC" }}
                          ></i>
                        </div>
                        <div className="add_new_text"></div>
                      </label>
                    </div>

                    <div className="newChain_addthree">
                      {/* mx-3 */}
                      {this.state.addIcon ? (
                        <img
                          src={this.state.addIcon}
                          className="newChain_addtwo"
                          // style={{ height: "100%", width: "100%" }}
                          alt="chain"
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="file-upload-superadmin-all-user-text">
                  <h3>Ashley Marathon</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-2">
                      <h4 className="heading-text-one">Over 21?</h4>
                    </div>
                    <div className="col-10">
                      <h4 className="heading-text-two">Yes</h4>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin mt-0">
                    <div className="col-3 d-flex align-items-center">
                      <h4 className="heading-text-one">Birthday</h4>
                    </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col-4">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col-4">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayMonth"
                            inputType="number"
                            placeHolder="MM"
                            name="birthdayMonth"
                            onChange={this.onChange}
                            value={this.state.birthdayMonth}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayMonth}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayMonth,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-3 d-flex align-items-center">
                      <h4 className="heading-text-one">Anniversary</h4>
                    </div>
                    <div className="col-9">
                      <div className="row">
                        <div className="col-4">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="anniversaryDate"
                            inputType="number"
                            placeHolder="DD"
                            name="anniversaryDate"
                            onChange={this.onChange}
                            value={this.state.anniversaryDate}
                            required="required"
                            showBottom={true}
                            error={errors.anniversaryDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.anniversaryDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col-4">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="anniversaryMonth"
                            inputType="number"
                            placeHolder="MM"
                            name="anniversaryMonth"
                            onChange={this.onChange}
                            value={this.state.anniversaryMonth}
                            required="required"
                            showBottom={true}
                            error={errors.anniversaryMonth}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.anniversaryMonth,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="super_admin_all_users_view_profile-margin mt-0">
                    <h4 className="heading-text-one">Phone</h4>
                    <h4 className="heading-text-two mt-2">+91- 8412856259</h4>
                  </div>
                  <div className="super_admin_all_users_view_profile-margin">
                    <h4 className="heading-text-one">Address</h4>
                    <h4 className="heading-text-three mt-2">
                      Shop no.5, Vrindavan Garden, Lane Number 6, Koregaon Park,
                      Pune, Maharashtra 411001.
                    </h4>
                  </div>
                </div>
              </div>

              {/*********************** Second Section Row *******************/}

              <div className="row">
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">
                        Add a special occasion <span>(optional)</span>
                      </h4>
                    </div>
                    <div className="col-9 mt-3">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="birthdayDate"
                        inputType="text"
                        placeHolder="Occasion"
                        name="birthdayDate"
                        onChange={this.onChange}
                        value={this.state.birthdayDate}
                        required="required"
                        showBottom={true}
                        error={errors.birthdayDate}
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.birthdayDate,
                          }
                        )}
                      />
                    </div>
                    <div className="col-9 mt-3">
                      <div className="row">
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/************** Second Section ***************/}
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">
                        Add a special occasion <span>(optional)</span>
                      </h4>
                    </div>
                    <div className="col-9 mt-3">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="birthdayDate"
                        inputType="text"
                        placeHolder="Occasion"
                        name="birthdayDate"
                        onChange={this.onChange}
                        value={this.state.birthdayDate}
                        required="required"
                        showBottom={true}
                        error={errors.birthdayDate}
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.birthdayDate,
                          }
                        )}
                      />
                    </div>
                    <div className="col-9 mt-3">
                      <div className="row">
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">
                        Add a special occasion <span>(optional)</span>
                      </h4>
                    </div>
                    <div className="col-9 mt-3">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="birthdayDate"
                        inputType="text"
                        placeHolder="Occasion"
                        name="birthdayDate"
                        onChange={this.onChange}
                        value={this.state.birthdayDate}
                        required="required"
                        showBottom={true}
                        error={errors.birthdayDate}
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.birthdayDate,
                          }
                        )}
                      />
                    </div>
                    <div className="col-9 mt-3">
                      <div className="row">
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/************** Second Section ***************/}
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">
                        Add a special occasion <span>(optional)</span>
                      </h4>
                    </div>
                    <div className="col-9 mt-3">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="birthdayDate"
                        inputType="text"
                        placeHolder="Occasion"
                        name="birthdayDate"
                        onChange={this.onChange}
                        value={this.state.birthdayDate}
                        required="required"
                        showBottom={true}
                        error={errors.birthdayDate}
                        inputClassName={classnames(
                          "input-component-inputfield",
                          {
                            invalid: errors.birthdayDate,
                          }
                        )}
                      />
                    </div>
                    <div className="col-9 mt-3">
                      <div className="row">
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                        <div className="col">
                          <InputBoxComponent
                            displayLabel={false}
                            controlId="birthdayDate"
                            inputType="number"
                            placeHolder="DD"
                            name="birthdayDate"
                            onChange={this.onChange}
                            value={this.state.birthdayDate}
                            required="required"
                            showBottom={true}
                            error={errors.birthdayDate}
                            inputClassName={classnames(
                              "input-component-inputfield",
                              {
                                invalid: errors.birthdayDate,
                              }
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*********************** Third Section Row *******************/}
              <div className="row">
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">Days Eat out</h4>
                    </div>
                    <div className="col-12">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.dayEatOut.map((data, index) => (
                          <ViewProfileDisplayButton
                            key={index}
                            buttonText={data.title}
                            className="super_admin_reusable_view_profile_button"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">Favorite Cuisines</h4>
                    </div>
                    <div className="col-8">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.favoriteCuisine.map((data, index) => (
                          <React.Fragment key={index}>
                            <ViewProfileDisplayButton
                              key={index}
                              buttonText={data.title}
                            />
                            <div>;&nbsp;</div>
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*********************** Fourth Section Row *******************/}
              <div className="row">
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">Favourite Places</h4>
                    </div>
                    <div className="col-12">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.favoritePlaces.map((data, index) => (
                          <ViewProfileDisplayButton
                            key={index}
                            buttonText={data.title}
                            className="super_admin_reusable_view_profile_buttontwo"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">
                        Favorite Popular Chains
                      </h4>
                    </div>
                    <div className="col-12">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.favoritePopularChains.map((data, index) => (
                          <ViewProfileDisplayButton
                            key={index}
                            src={data.icon}
                            className="super_admin_reusable_view_profile_buttontwo"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/*********************** Fifth Section Row *******************/}
              <div className="row">
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">Dietary Preferences</h4>
                    </div>
                    <div className="col-12">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.dietaryPreferences.map((data, index) => (
                          <ViewProfileDisplayButton
                            key={index}
                            buttonText={data.title}
                            className="super_admin_reusable_view_profile_buttontwo"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row super_admin_all_users_view_profile-margin">
                    <div className="col-12 d-flex align-items-center">
                      <h4 className="heading-text-one">Your Allergy Info</h4>
                    </div>
                    <div className="col-12">
                      <div
                        className="super_admin_all_view_profile-box "
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          width: "75%",
                        }}
                      >
                        {this.state.yourAllergyInfo.map((data, index) => (
                          <ViewProfileDisplayButton
                            key={index}
                            buttonText={data.title}
                            className="super_admin_reusable_view_profile_buttontwo"
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default SuperAdminProfilePopup;
